import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import ReactDOM from 'react-dom'
import ReactSwipe from 'react-swipe'

import styles from './styles.css'
import Icon from '_components/icon'

class CategoryTabBodyTimeframe extends PureComponent {
  static propTypes = {
    children: PropTypes.element.isRequired,
    selectedTimeframe: PropTypes.string.isRequired,
    timeframes: PropTypes.object.isRequired,
    onChangeTimeframe: PropTypes.func.isRequired,
  }

  onTimeframeClick = e => {
    const { onChangeTimeframe } = this.props
    onChangeTimeframe(e)
  }

  render() {
    const { children, timeframes, selectedTimeframe } = this.props
    const timeframeKeys = Object.keys(timeframes)

    return (
      <div className={classnames(styles.container)}>
        <div className={classnames(styles.childrenContainer)}>{children}</div>
        <div className={classnames(styles.timeframeContainer)}>
          {timeframeKeys.map(k => (
            <span
              key={k}
              id={k}
              className={classnames(styles.timeframeLabel)}
              style={{
                color: selectedTimeframe === k ? 'rgba(255,255,255,0.8)' : 'rgba(255,255,255, 0.4)',
                cursor: 'pointer',
              }}
              onClick={this.onTimeframeClick}
            >
              {k}
            </span>
          ))}
        </div>
      </div>
    )
  }
}

export default CategoryTabBodyTimeframe



// WEBPACK FOOTER //
// ./src/components/categoryTabs/categoryTabBodyTimeframe/index.js